export default __webpack_public_path__ + "static/media/header-background.f6ce8f64.jpg";